var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityAndLoginChangePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 930.5,
    height: 670.286,
    viewBox: "0 0 930.5 670.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_and_login_change_password",
    transform: "translate(-83.418 -32.372)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-16",
    transform: "translate(83.918 32.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7039",
    "data-name": "Group 7039",
    transform: "translate(732.637 510.956)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46917",
    "data-name": "Path 46917",
    d: "M383.4,286.115a2.33,2.33,0,0,1-1.735-3.173l.124-.322a2.33,2.33,0,0,1,3.222-1.413,27.51,27.51,0,0,1,5.726,3.024,27.267,27.267,0,0,1-1.091-6.593,2.479,2.479,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,28.382,28.382,0,0,1-1.066,6.593,30.09,30.09,0,0,1,5.7-3.024,2.305,2.305,0,0,1,3.223,1.463v.223a2.3,2.3,0,0,1-1.685,3.222,28.163,28.163,0,0,1-6.37.942,26.925,26.925,0,0,1,4.759,4.486,2.479,2.479,0,0,1-.4,3.495l-.273.223a2.33,2.33,0,0,1-3.569-.694,30.066,30.066,0,0,1-2.95-5.825,32.872,32.872,0,0,1-3.024,5.825,2.33,2.33,0,0,1-3.569.694l-.248-.223a2.479,2.479,0,0,1-.421-3.495,31.534,31.534,0,0,1,4.784-4.561A25.409,25.409,0,0,1,383.4,286.115Z",
    transform: "translate(-381.49 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46918",
    "data-name": "Path 46918",
    d: "M393.538,286.115a2.33,2.33,0,0,1-1.735-3.173l.124-.322a2.33,2.33,0,0,1,3.222-1.413,27.505,27.505,0,0,1,5.726,3.024,27.27,27.27,0,0,1-1.09-6.593,2.479,2.479,0,0,1,2.479-2.628h.2a2.479,2.479,0,0,1,2.479,2.627,28.37,28.37,0,0,1-1.066,6.593,30.092,30.092,0,0,1,5.7-3.024,2.479,2.479,0,0,1,3.247,1.462v.223a2.3,2.3,0,0,1-1.685,3.222,28.163,28.163,0,0,1-6.37.942,26.921,26.921,0,0,1,4.759,4.486,2.479,2.479,0,0,1-.4,3.495l-.273.223a2.3,2.3,0,0,1-3.544-.694,28.674,28.674,0,0,1-2.975-5.825,32.874,32.874,0,0,1-3.024,5.825,2.33,2.33,0,0,1-3.569.694l-.248-.223a2.479,2.479,0,0,1-.421-3.495,31.524,31.524,0,0,1,4.784-4.561,25.41,25.41,0,0,1-6.321-.868Z",
    transform: "translate(-366.496 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46919",
    "data-name": "Path 46919",
    d: "M403.649,286.115a2.479,2.479,0,0,1-1.735-3.173l.124-.322a2.33,2.33,0,0,1,3.222-1.413,27.509,27.509,0,0,1,5.726,3.024,27.274,27.274,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,28.379,28.379,0,0,1-1.066,6.593,30.09,30.09,0,0,1,5.7-3.024,2.479,2.479,0,0,1,3.247,1.462v.223a2.305,2.305,0,0,1-1.661,3.222,28.606,28.606,0,0,1-6.395.942,26.917,26.917,0,0,1,4.759,4.486,2.479,2.479,0,0,1-.4,3.495l-.273.223a2.305,2.305,0,0,1-3.545-.694,30.006,30.006,0,0,1-2.974-5.825,32.872,32.872,0,0,1-3.024,5.825,2.305,2.305,0,0,1-3.544.694l-.273-.223a2.479,2.479,0,0,1-.421-3.495,31.526,31.526,0,0,1,4.784-4.561,25.409,25.409,0,0,1-6.494-.868Z",
    transform: "translate(-351.472 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46920",
    "data-name": "Path 46920",
    d: "M413.789,286.115a2.479,2.479,0,0,1-1.735-3.173v-.322a2.33,2.33,0,0,1,3.222-1.413A27.505,27.505,0,0,1,421,284.231a28.38,28.38,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,28.382,28.382,0,0,1-1.066,6.593,30.088,30.088,0,0,1,5.7-3.024,2.479,2.479,0,0,1,3.247,1.462v.223a2.305,2.305,0,0,1-1.661,3.222,28.613,28.613,0,0,1-6.4.942,26.923,26.923,0,0,1,4.759,4.486,2.479,2.479,0,0,1-.4,3.495l-.273.223a2.305,2.305,0,0,1-3.544-.694,30,30,0,0,1-2.974-5.825,32.877,32.877,0,0,1-3.1,5.825,2.305,2.305,0,0,1-3.544.694l-.273-.223a2.479,2.479,0,0,1-.421-3.5,31.524,31.524,0,0,1,4.784-4.561,25.411,25.411,0,0,1-6.3-.868Z",
    transform: "translate(-336.478 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46921",
    "data-name": "Path 46921",
    d: "M423.929,286.115a2.479,2.479,0,0,1-1.735-3.173l.124-.322a2.478,2.478,0,0,1,3.247-1.413,28.009,28.009,0,0,1,5.7,3.024,28.379,28.379,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.479-2.628h.347a2.479,2.479,0,0,1,2.479,2.627,28.369,28.369,0,0,1-1.066,6.593,30.094,30.094,0,0,1,5.7-3.024,2.479,2.479,0,0,1,3.247,1.462v.223a2.305,2.305,0,0,1-1.661,3.222,28.612,28.612,0,0,1-6.4.942,26.92,26.92,0,0,1,4.759,4.486,2.479,2.479,0,0,1-.4,3.495l-.273.223a2.305,2.305,0,0,1-3.545-.694,30,30,0,0,1-2.974-5.825,32.868,32.868,0,0,1-3.024,5.825,2.305,2.305,0,0,1-3.544.694l-.273-.223a2.33,2.33,0,0,1-.4-3.495,30.138,30.138,0,0,1,4.759-4.561A25.412,25.412,0,0,1,423.929,286.115Z",
    transform: "translate(-321.484 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46922",
    "data-name": "Path 46922",
    d: "M434.109,286.115a2.479,2.479,0,0,1-1.735-3.173l.124-.322a2.479,2.479,0,0,1,3.247-1.413,28.005,28.005,0,0,1,5.7,3.024,28.388,28.388,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,28.388,28.388,0,0,1-1.066,6.593,29.5,29.5,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.462v.223a2.305,2.305,0,0,1-1.661,3.222,28.377,28.377,0,0,1-6.395.942,28.044,28.044,0,0,1,4.784,4.486,2.479,2.479,0,0,1-.421,3.495l-.272.223a2.305,2.305,0,0,1-3.545-.694,29.99,29.99,0,0,1-2.975-5.825,32.878,32.878,0,0,1-3.024,5.825,2.305,2.305,0,0,1-3.544.694l-.273-.223a2.33,2.33,0,0,1-.4-3.495,30.132,30.132,0,0,1,4.759-4.561,25.407,25.407,0,0,1-6.494-.867Z",
    transform: "translate(-306.431 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46923",
    "data-name": "Path 46923",
    d: "M444.232,286.115a2.479,2.479,0,0,1-1.76-3.173l.124-.322a2.479,2.479,0,0,1,3.247-1.413,28,28,0,0,1,5.7,3.024,28.385,28.385,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.264,27.264,0,0,1-1.091,6.593,29.489,29.489,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.462v.223a2.3,2.3,0,0,1-1.685,3.222,28.378,28.378,0,0,1-6.4.942,28.042,28.042,0,0,1,4.784,4.487,2.479,2.479,0,0,1-.422,3.495l-.248.223a2.33,2.33,0,0,1-3.569-.694,28.736,28.736,0,0,1-2.95-5.825,32.769,32.769,0,0,1-3.049,5.825,2.305,2.305,0,0,1-3.545.694l-.273-.223a2.33,2.33,0,0,1-.4-3.495,30.143,30.143,0,0,1,4.759-4.561A25.035,25.035,0,0,1,444.232,286.115Z",
    transform: "translate(-291.495 -275.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46924",
    "data-name": "Path 46924",
    d: "M454.372,286.115a2.479,2.479,0,0,1-1.76-3.173v-.322a2.479,2.479,0,0,1,3.247-1.413,28.009,28.009,0,0,1,5.7,3.024,28.378,28.378,0,0,1-1.066-6.593,2.479,2.479,0,0,1,2.478-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.264,27.264,0,0,1-1.091,6.593,29.488,29.488,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.462v.223a2.305,2.305,0,0,1-1.685,3.222,28.377,28.377,0,0,1-6.4.942,28.04,28.04,0,0,1,4.784,4.486,2.479,2.479,0,0,1-.421,3.495l-.273.223a2.305,2.305,0,0,1-3.545-.694,28.742,28.742,0,0,1-2.949-5.825,32.771,32.771,0,0,1-3.049,5.825,2.305,2.305,0,0,1-3.544.694l-.273-.223a2.33,2.33,0,0,1-.4-3.495,30.133,30.133,0,0,1,4.759-4.561,25.037,25.037,0,0,1-6.3-.868Z",
    transform: "translate(-276.501 -275.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7040",
    "data-name": "Group 7040",
    transform: "translate(161.355 77.6)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46925",
    "data-name": "Path 46925",
    d: "M183.937,61.613a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.323,29.323,0,0,1,5.7,3.024,28.381,28.381,0,0,1-1.066-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.479,2.479,0,0,1,2.479,2.6,27.267,27.267,0,0,1-1.091,6.593A30.913,30.913,0,0,1,200,56.656a2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.685,3.222,28.16,28.16,0,0,1-6.4.942,27.268,27.268,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.745,29.745,0,0,1-2.875-5.949,34.113,34.113,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,30.2,30.2,0,0,1,4.759-4.586,25.21,25.21,0,0,1-6.37-.719Z",
    transform: "translate(-182.015 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46926",
    "data-name": "Path 46926",
    d: "M194.077,61.613a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.628,28.628,0,0,1,5.7,3.024,28.384,28.384,0,0,1-1.066-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,27.265,27.265,0,0,1-1.091,6.593,30.912,30.912,0,0,1,5.627-3.074,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.686,3.222,28.158,28.158,0,0,1-6.4.942,27.265,27.265,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.747,29.747,0,0,1-2.875-5.949,34.115,34.115,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,31.308,31.308,0,0,1,4.759-4.586,25.209,25.209,0,0,1-6.37-.719Z",
    transform: "translate(-167.02 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46927",
    "data-name": "Path 46927",
    d: "M204.217,61.613a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.63,28.63,0,0,1,5.7,3.024,28.388,28.388,0,0,1-1.066-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,27.266,27.266,0,0,1-1.091,6.593,30.913,30.913,0,0,1,5.627-3.074,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.686,3.222,28.159,28.159,0,0,1-6.395.942,27.269,27.269,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.751,29.751,0,0,1-2.875-5.949,34.112,34.112,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,31.3,31.3,0,0,1,4.759-4.586A25.207,25.207,0,0,1,204.217,61.613Z",
    transform: "translate(-152.026 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46928",
    "data-name": "Path 46928",
    d: "M214.357,61.613a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.631,28.631,0,0,1,5.7,3.024,28.382,28.382,0,0,1-1.066-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,27.268,27.268,0,0,1-1.091,6.593,30.913,30.913,0,0,1,5.627-3.074,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.685,3.222,28.159,28.159,0,0,1-6.4.942,27.267,27.267,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.445-.669,29.747,29.747,0,0,1-3-5.949,34.115,34.115,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,31.306,31.306,0,0,1,4.759-4.586,25.208,25.208,0,0,1-6.37-.719Z",
    transform: "translate(-137.032 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46929",
    "data-name": "Path 46929",
    d: "M224.5,61.643a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.462,28.626,28.626,0,0,1,5.7,3.024,28.386,28.386,0,0,1-1.066-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,28.379,28.379,0,0,1-1.066,6.593,30.042,30.042,0,0,1,5.7-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.686,3.222,28.159,28.159,0,0,1-6.4.942,27.263,27.263,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.747,29.747,0,0,1-2.975-5.949,34.1,34.1,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,30.442,30.442,0,0,1,4.784-4.586,25.234,25.234,0,0,1-6.4-.719Z",
    transform: "translate(-122.038 -50.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46930",
    "data-name": "Path 46930",
    d: "M234.608,61.613a2.479,2.479,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.445,29.445,0,0,1,5.726,3.024,27.265,27.265,0,0,1-1.091-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,28.381,28.381,0,0,1-1.066,6.593,30.786,30.786,0,0,1,5.676-3.074,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.686,3.222,28.157,28.157,0,0,1-6.37.942,27.862,27.862,0,0,1,4.833,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.746,29.746,0,0,1-3.024-5.949,34.11,34.11,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5A30.441,30.441,0,0,1,241,62.332,25.234,25.234,0,0,1,234.608,61.613Z",
    transform: "translate(-107.016 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46931",
    "data-name": "Path 46931",
    d: "M244.769,61.613a2.305,2.305,0,0,1-1.735-3.148v-.347a2.33,2.33,0,0,1,3.222-1.413,29.447,29.447,0,0,1,5.726,3.024,27.263,27.263,0,0,1-1.091-6.593,2.479,2.479,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6A28.384,28.384,0,0,1,255.1,59.73a30.79,30.79,0,0,1,5.7-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.686,3.222,28.156,28.156,0,0,1-6.37.942,27.862,27.862,0,0,1,4.759,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.745,29.745,0,0,1-2.851-6,34.106,34.106,0,0,1-3,5.949,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,30.436,30.436,0,0,1,4.784-4.586,25.232,25.232,0,0,1-6.42-.818Z",
    transform: "translate(-92.042 -50.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46932",
    "data-name": "Path 46932",
    d: "M254.909,61.613a2.305,2.305,0,0,1-1.735-3.148l.124-.347a2.33,2.33,0,0,1,3.222-1.413,29.447,29.447,0,0,1,5.726,3.024,27.268,27.268,0,0,1-1.091-6.593,2.33,2.33,0,0,1,2.479-2.6h.322a2.33,2.33,0,0,1,2.479,2.6,28.378,28.378,0,0,1-1.066,6.593,30.782,30.782,0,0,1,5.7-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.305,2.305,0,0,1-1.685,3.222,28.158,28.158,0,0,1-6.37.942A27.866,27.866,0,0,1,271,67.067a2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.739,29.739,0,0,1-2.974-6,34.115,34.115,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,30.448,30.448,0,0,1,4.784-4.586,25.234,25.234,0,0,1-6.4-.719Z",
    transform: "translate(-77.048 -50.478)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041",
    transform: "translate(475.854 631.344)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46933",
    "data-name": "Path 46933",
    d: "M268.817,378.194a2.33,2.33,0,0,1-1.76-3.148l.124-.347a2.479,2.479,0,0,1,3.247-1.413,29.319,29.319,0,0,1,5.7,3.024,28.409,28.409,0,0,1-1.066-6.569,2.33,2.33,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.268,27.268,0,0,1-1.091,6.569A30.91,30.91,0,0,1,285,373.286a2.33,2.33,0,0,1,3.222,1.487v.2a2.281,2.281,0,0,1-1.685,3.222,27.047,27.047,0,0,1-6.4.942,29.121,29.121,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.421,3.5l-.248.2a2.479,2.479,0,0,1-3.569-.669,29,29,0,0,1-2.95-5.85,33.1,33.1,0,0,1-3.148,5.85,2.33,2.33,0,0,1-3.545.669l-.272-.2a2.33,2.33,0,0,1-.4-3.495,30.15,30.15,0,0,1,4.759-4.561,24.962,24.962,0,0,1-6.321-.892Z",
    transform: "translate(-266.895 -367.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46934",
    "data-name": "Path 46934",
    d: "M278.957,378.194a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.321,29.321,0,0,1,5.7,3.024,28.41,28.41,0,0,1-1.066-6.569,2.33,2.33,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.266,27.266,0,0,1-1.091,6.569,30.909,30.909,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.28,2.28,0,0,1-1.686,3.222,27.037,27.037,0,0,1-6.4.942,29.128,29.128,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.421,3.5l-.248.2a2.479,2.479,0,0,1-3.569-.669,29.009,29.009,0,0,1-2.95-5.85,33.192,33.192,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.33,2.33,0,0,1-.4-3.495,30.141,30.141,0,0,1,4.759-4.561,24.958,24.958,0,0,1-6.42-.892Z",
    transform: "translate(-251.901 -367.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46935",
    "data-name": "Path 46935",
    d: "M289.147,378.194a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.32,29.32,0,0,1,5.7,3.024,28.4,28.4,0,0,1-1.066-6.569,2.33,2.33,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.26,27.26,0,0,1-1.091,6.569,30.915,30.915,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.28,2.28,0,0,1-1.685,3.222,27.048,27.048,0,0,1-6.4.942,29.133,29.133,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.421,3.495l-.248.2a2.479,2.479,0,0,1-3.569-.669,29,29,0,0,1-2.95-5.85,33.187,33.187,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,30.144,30.144,0,0,1,4.759-4.561,25.129,25.129,0,0,1-6.42-.892Z",
    transform: "translate(-236.833 -367.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46936",
    "data-name": "Path 46936",
    d: "M299.237,378.194a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.317,29.317,0,0,1,5.7,3.024,28.418,28.418,0,0,1-1.066-6.569,2.33,2.33,0,0,1,2.479-2.627h.347a2.479,2.479,0,0,1,2.479,2.627,27.268,27.268,0,0,1-1.091,6.569,30.914,30.914,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.28,2.28,0,0,1-1.685,3.222,26.843,26.843,0,0,1-6.395.942,29.121,29.121,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.5l-.273.2a2.479,2.479,0,0,1-3.569-.669,29.005,29.005,0,0,1-2.95-5.85,33.194,33.194,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.5,31.287,31.287,0,0,1,4.759-4.561,25.133,25.133,0,0,1-6.42-.892Z",
    transform: "translate(-221.912 -367.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46937",
    "data-name": "Path 46937",
    d: "M309.377,378.19a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,29.331,29.331,0,0,1,5.7,3.024,28.406,28.406,0,0,1-1.066-6.569,2.479,2.479,0,0,1,2.479-2.627h.322a2.479,2.479,0,0,1,2.479,2.627,27.269,27.269,0,0,1-1.091,6.569,30.906,30.906,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.28,2.28,0,0,1-1.686,3.222,26.836,26.836,0,0,1-6.4.942,29.124,29.124,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.594-.669,29,29,0,0,1-2.95-5.85,33.2,33.2,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,31.275,31.275,0,0,1,4.759-4.561A25.137,25.137,0,0,1,309.377,378.19Z",
    transform: "translate(-206.918 -367.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46938",
    "data-name": "Path 46938",
    d: "M319.517,378.19a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.634,28.634,0,0,1,5.7,3.024,28.4,28.4,0,0,1-1.066-6.568,2.479,2.479,0,0,1,2.479-2.628h.273a2.479,2.479,0,0,1,2.479,2.627,27.264,27.264,0,0,1-1.091,6.569,30.913,30.913,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.28,2.28,0,0,1-1.685,3.222,26.837,26.837,0,0,1-6.4.942,29.127,29.127,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29,29,0,0,1-2.95-5.85,33.2,33.2,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,32.47,32.47,0,0,1,4.759-4.561A25.136,25.136,0,0,1,319.517,378.19Z",
    transform: "translate(-191.924 -367.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46939",
    "data-name": "Path 46939",
    d: "M329.657,378.19a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.624,28.624,0,0,1,5.7,3.024,28.413,28.413,0,0,1-1.066-6.569,2.479,2.479,0,0,1,2.479-2.627h.322a2.479,2.479,0,0,1,2.479,2.627,27.266,27.266,0,0,1-1.091,6.569,30.9,30.9,0,0,1,5.651-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.281,2.281,0,0,1-1.686,3.222,26.849,26.849,0,0,1-6.395.942,29.118,29.118,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29,29,0,0,1-2.95-5.85,33.2,33.2,0,0,1-3.024,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495A31.524,31.524,0,0,1,336,379.082a25.184,25.184,0,0,1-6.346-.892Z",
    transform: "translate(-176.93 -367.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46940",
    "data-name": "Path 46940",
    d: "M339.8,378.19a2.33,2.33,0,0,1-1.76-3.148l.149-.347a2.33,2.33,0,0,1,3.222-1.413,28.631,28.631,0,0,1,5.7,3.024,28.4,28.4,0,0,1-1.066-6.568,2.479,2.479,0,0,1,2.479-2.628h.322a2.479,2.479,0,0,1,2.479,2.627,27.267,27.267,0,0,1-1.091,6.569,30.905,30.905,0,0,1,5.726-3.024,2.33,2.33,0,0,1,3.222,1.487v.2a2.281,2.281,0,0,1-1.685,3.222,26.852,26.852,0,0,1-6.4.942,29.126,29.126,0,0,1,4.784,4.511,2.479,2.479,0,0,1-.4,3.495l-.273.2a2.479,2.479,0,0,1-3.569-.669,29,29,0,0,1-2.95-5.85,33.2,33.2,0,0,1-3.074,5.85,2.479,2.479,0,0,1-3.569.669l-.273-.2a2.479,2.479,0,0,1-.4-3.495,31.531,31.531,0,0,1,4.784-4.561,25.184,25.184,0,0,1-6.37-.892Z",
    transform: "translate(-161.936 -367.104)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042",
    transform: "translate(840.386 593.401)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46941",
    "data-name": "Path 46941",
    d: "M432.509,339.811V325.858a15.952,15.952,0,0,1,31.884,0v13.855h6.349V325.858a22.3,22.3,0,0,0-44.583,0v13.953Z",
    transform: "translate(-423.808 -304.217)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11590",
    "data-name": "Rectangle 11590",
    width: 48.659,
    height: 40.252,
    transform: "translate(0 35.633)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46942",
    "data-name": "Path 46942",
    d: "M445.192,333.373a5.311,5.311,0,0,0-10.6,0,5.155,5.155,0,0,0,2.783,4.566l-.9,9.132h6.761l-.882-9.132A5.193,5.193,0,0,0,445.192,333.373Z",
    transform: "translate(-415.718 -281.024)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7043",
    "data-name": "Group 7043",
    transform: "translate(0 313.496)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46943",
    "data-name": "Path 46943",
    d: "M90.892,173.537V137.128a41.509,41.509,0,0,1,82.967,0V173.18H190.38V137.128a58.031,58.031,0,0,0-116.01,0v36.409Z",
    transform: "translate(-68.251 -80.817)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11591",
    "data-name": "Rectangle 11591",
    width: 126.617,
    height: 104.741,
    transform: "translate(0 92.72)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46944",
    "data-name": "Path 46944",
    d: "M110.348,117.965a13.819,13.819,0,0,0-27.588,0A13.412,13.412,0,0,0,90,129.846L87.655,153.66H105.4l-2.295-23.814a13.513,13.513,0,0,0,7.241-11.882Z",
    transform: "translate(-33.857 18.252)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7044",
    "data-name": "Group 7044",
    transform: "translate(741.705 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46945",
    "data-name": "Path 46945",
    d: "M398.342,106.521V78.231a32.349,32.349,0,0,1,64.637,0v28.108h12.9V78.231a45.191,45.191,0,0,0-90.382,0v28.29Z",
    transform: "translate(-380.714 -33.04)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11592",
    "data-name": "Rectangle 11592",
    width: 98.681,
    height: 81.659,
    transform: "translate(0 73.541)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46946",
    "data-name": "Path 46946",
    d: "M412.505,59.108a10.783,10.783,0,0,0-21.505,0,10.419,10.419,0,0,0,5.634,9.208l-1.817,18.6h13.812l-1.757-18.6a10.419,10.419,0,0,0,5.633-9.208Z",
    transform: "translate(-352.897 48.357)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-16",
    transform: "translate(96.113 104.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11593",
    "data-name": "Rectangle 11593",
    width: 906.132,
    height: 481.251,
    transform: "translate(0.769 44.099)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11594",
    "data-name": "Rectangle 11594",
    width: 748.211,
    height: 45.124,
    transform: "translate(158.661 44.099)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11595",
    "data-name": "Rectangle 11595",
    width: 589.521,
    height: 45.124,
    transform: "translate(317.351 44.099)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11596",
    "data-name": "Rectangle 11596",
    width: 906.872,
    height: 45.124,
    transform: "translate(0 0)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46947",
    "data-name": "Path 46947",
    d: "M726.91,94.842H137.275a9.765,9.765,0,0,1-9.765-9.765h0a9.737,9.737,0,0,1,9.765-9.737H726.91a9.765,9.765,0,0,1,9.765,9.737h0a9.794,9.794,0,0,1-9.765,9.765Z",
    transform: "translate(-97.304 -63.354)",
    fill: "#e5f1fb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 8.199,
    cy: 8.199,
    rx: 8.199,
    ry: 8.199,
    transform: "translate(799.399 14.833)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46948",
    "data-name": "Path 46948",
    d: "M426.136,84.576a8.228,8.228,0,1,0-8.2,8.2,8.228,8.228,0,0,0,8.2-8.2Z",
    transform: "translate(423.854 -61.544)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 8.199,
    cy: 8.199,
    rx: 8.199,
    ry: 8.199,
    transform: "translate(867.755 14.833)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46949",
    "data-name": "Path 46949",
    d: "M137.73,209.487H238.484V141.1H180.007l-5.95-16.683H137.73Z",
    transform: "translate(-78.428 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46950",
    "data-name": "Path 46950",
    d: "M137.73,255.877H238.484V187.493H180.007l-5.95-16.683H137.73Z",
    transform: "translate(-78.428 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46951",
    "data-name": "Path 46951",
    d: "M137.73,302.286H238.484V233.9H180.007l-5.95-16.712H137.73Z",
    transform: "translate(-78.428 198.638)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46952",
    "data-name": "Path 46952",
    d: "M186.9,209.487H287.626V141.1H229.149l-5.922-16.683H186.9Z",
    transform: "translate(12.387 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46953",
    "data-name": "Path 46953",
    d: "M186.9,255.877H287.626V187.493H229.149l-5.922-16.683H186.9Z",
    transform: "translate(12.387 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46954",
    "data-name": "Path 46954",
    d: "M186.9,302.286H287.626V233.9H229.149l-5.922-16.712H186.9Z",
    transform: "translate(12.387 198.638)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46955",
    "data-name": "Path 46955",
    d: "M236.06,209.487H336.786V141.1H278.337l-5.95-16.683H236.06Z",
    transform: "translate(103.184 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46956",
    "data-name": "Path 46956",
    d: "M236.06,255.877H336.786V187.493H278.337l-5.95-16.683H236.06Z",
    transform: "translate(103.184 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46957",
    "data-name": "Path 46957",
    d: "M236.06,302.286H336.786V233.9H278.337l-5.95-16.712H236.06Z",
    transform: "translate(103.184 198.638)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46958",
    "data-name": "Path 46958",
    d: "M285.22,209.487H385.974V141.1H327.5l-5.95-16.683H285.22Z",
    transform: "translate(193.981 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46959",
    "data-name": "Path 46959",
    d: "M285.22,255.877H385.974V187.493H327.5l-5.95-16.683H285.22Z",
    transform: "translate(193.981 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46960",
    "data-name": "Path 46960",
    d: "M285.22,302.286H385.974V233.9H327.5l-5.95-16.712H285.22Z",
    transform: "translate(193.981 198.638)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46961",
    "data-name": "Path 46961",
    d: "M334.39,209.487H435.116V141.1H376.639l-5.922-16.683H334.39Z",
    transform: "translate(284.796 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46962",
    "data-name": "Path 46962",
    d: "M334.39,255.877H435.116V187.493H376.639l-5.922-16.683H334.39Z",
    transform: "translate(284.796 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46963",
    "data-name": "Path 46963",
    d: "M334.39,302.286H435.116V233.9H376.639l-5.922-16.712H334.39Z",
    transform: "translate(284.796 198.638)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46964",
    "data-name": "Path 46964",
    d: "M383.55,209.487H484.3V141.1H425.828l-5.95-16.683H383.55Z",
    transform: "translate(375.593 27.295)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46965",
    "data-name": "Path 46965",
    d: "M383.55,255.877H484.3V187.493H425.828l-5.95-16.683H383.55Z",
    transform: "translate(375.593 112.975)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46966",
    "data-name": "Path 46966",
    d: "M383.55,302.286H484.3V233.9H425.828l-5.95-16.712H383.55Z",
    transform: "translate(375.593 198.638)",
    fill: "#e5f1fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-16",
    transform: "translate(362.918 199.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11597",
    "data-name": "Rectangle 11597",
    width: 362.988,
    height: 320.283,
    transform: "translate(0 16.37)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11598",
    "data-name": "Rectangle 11598",
    width: 362.988,
    height: 320.283,
    transform: "translate(9.11 0)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11599",
    "data-name": "Rectangle 11599",
    width: 362.988,
    height: 22.89,
    transform: "translate(9.11 0)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46967",
    "data-name": "Path 46967",
    d: "M273.324,205.345V171.58a23.146,23.146,0,1,1,46.292,0v19.729h9.224V171.58a32.37,32.37,0,1,0-64.74,0v33.765Z",
    transform: "translate(-105.41 -68.178)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11600",
    "data-name": "Rectangle 11600",
    width: 70.69,
    height: 58.477,
    transform: "translate(155.245 133.864)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    "data-name": "Line 401",
    y1: 10.477,
    x2: 4.584,
    transform: "translate(236.013 101.95)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    x2: 17.025,
    transform: "translate(236.668 124.839)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    x2: 9.167,
    y2: 9.822,
    transform: "translate(234.704 136.626)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46968",
    "data-name": "Path 46968",
    d: "M287.9,174.914a7.715,7.715,0,1,0-11.388,6.633l-1.281,13.3h9.879l-1.281-13.3A7.487,7.487,0,0,0,287.9,174.914Z",
    transform: "translate(-89.951 -16.765)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11601",
    "data-name": "Rectangle 11601",
    width: 275.899,
    height: 49.793,
    rx: 4,
    transform: "translate(52.64 216.17)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46969",
    "data-name": "Path 46969",
    d: "M237.682,207.764a2.676,2.676,0,0,1-1.993-3.644l.142-.37a2.676,2.676,0,0,1,3.7-1.623,31.6,31.6,0,0,1,6.577,3.473,31.315,31.315,0,0,1-1.253-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,32.6,32.6,0,0,1-1.224,7.573,34.568,34.568,0,0,1,6.548-3.473,2.648,2.648,0,0,1,3.7,1.68v.256a2.648,2.648,0,0,1-1.936,3.7,32.344,32.344,0,0,1-7.317,1.082A30.917,30.917,0,0,1,256.187,214a2.847,2.847,0,0,1-.456,4.014l-.313.256a2.676,2.676,0,0,1-4.1-.8,34.523,34.523,0,0,1-3.388-6.69,37.754,37.754,0,0,1-3.473,6.69,2.676,2.676,0,0,1-4.1.8l-.285-.256a2.847,2.847,0,0,1-.484-4.014,36.213,36.213,0,0,1,5.495-5.238,29.187,29.187,0,0,1-7.4-1Z",
    transform: "translate(-158.252 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46970",
    "data-name": "Path 46970",
    d: "M247.822,207.764a2.676,2.676,0,0,1-1.993-3.644l.142-.37a2.676,2.676,0,0,1,3.7-1.623,31.6,31.6,0,0,1,6.577,3.473A31.318,31.318,0,0,1,255,198.028a2.847,2.847,0,0,1,2.847-3.018h.228a2.847,2.847,0,0,1,2.847,3.018,32.6,32.6,0,0,1-1.224,7.573,34.57,34.57,0,0,1,6.548-3.473,2.847,2.847,0,0,1,3.729,1.68v.256a2.648,2.648,0,0,1-1.936,3.7,32.342,32.342,0,0,1-7.317,1.082A30.919,30.919,0,0,1,266.185,214a2.847,2.847,0,0,1-.456,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,32.932,32.932,0,0,1-3.416-6.69,37.746,37.746,0,0,1-3.473,6.69,2.676,2.676,0,0,1-4.1.8l-.285-.256a2.847,2.847,0,0,1-.484-4.014,36.219,36.219,0,0,1,5.495-5.238,29.186,29.186,0,0,1-7.26-1Z",
    transform: "translate(-139.523 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46971",
    "data-name": "Path 46971",
    d: "M257.925,207.764a2.847,2.847,0,0,1-1.993-3.644v-.37a2.676,2.676,0,0,1,3.7-1.623,31.593,31.593,0,0,1,6.577,3.473,31.319,31.319,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,32.6,32.6,0,0,1-1.224,7.573,34.553,34.553,0,0,1,6.548-3.473,2.847,2.847,0,0,1,3.729,1.68v.256a2.648,2.648,0,0,1-1.907,3.7,32.859,32.859,0,0,1-7.345,1.082A30.911,30.911,0,0,1,276.345,214a2.847,2.847,0,0,1-.455,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,34.456,34.456,0,0,1-3.416-6.69,37.759,37.759,0,0,1-3.473,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256a2.847,2.847,0,0,1-.484-4.014,36.219,36.219,0,0,1,5.495-5.238,29.186,29.186,0,0,1-7.317-1Z",
    transform: "translate(-120.758 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46972",
    "data-name": "Path 46972",
    d: "M268.065,207.764a2.847,2.847,0,0,1-1.993-3.644v-.37a2.676,2.676,0,0,1,3.7-1.623,31.6,31.6,0,0,1,6.577,3.473,32.593,32.593,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,32.6,32.6,0,0,1-1.224,7.573,34.552,34.552,0,0,1,6.548-3.473,2.847,2.847,0,0,1,3.73,1.68v.256a2.648,2.648,0,0,1-1.908,3.7,32.854,32.854,0,0,1-7.345,1.082A30.91,30.91,0,0,1,286.485,214a2.847,2.847,0,0,1-.456,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,34.455,34.455,0,0,1-3.416-6.69,37.749,37.749,0,0,1-3.559,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256A2.847,2.847,0,0,1,269.8,214a36.206,36.206,0,0,1,5.495-5.238A29.185,29.185,0,0,1,268.065,207.764Z",
    transform: "translate(-102.03 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46973",
    "data-name": "Path 46973",
    d: "M278.205,207.764a2.847,2.847,0,0,1-1.993-3.644l.142-.37a2.847,2.847,0,0,1,3.73-1.623,32.163,32.163,0,0,1,6.548,3.473,32.593,32.593,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,32.6,32.6,0,0,1-1.224,7.573,34.554,34.554,0,0,1,6.548-3.473,2.847,2.847,0,0,1,3.729,1.68v.256a2.647,2.647,0,0,1-1.907,3.7,32.857,32.857,0,0,1-7.345,1.082A30.916,30.916,0,0,1,296.767,214a2.847,2.847,0,0,1-.456,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,34.445,34.445,0,0,1-3.416-6.69,37.76,37.76,0,0,1-3.474,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256A2.676,2.676,0,0,1,280.2,214a34.627,34.627,0,0,1,5.466-5.238,29.181,29.181,0,0,1-7.459-1Z",
    transform: "translate(-83.302 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46974",
    "data-name": "Path 46974",
    d: "M288.385,207.764a2.847,2.847,0,0,1-1.993-3.644l.142-.37a2.847,2.847,0,0,1,3.729-1.623,32.169,32.169,0,0,1,6.548,3.473,32.591,32.591,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,32.594,32.594,0,0,1-1.224,7.573,33.871,33.871,0,0,1,6.576-3.473,2.676,2.676,0,0,1,3.7,1.68v.256a2.648,2.648,0,0,1-1.907,3.7,32.6,32.6,0,0,1-7.345,1.082A32.191,32.191,0,0,1,306.976,214a2.847,2.847,0,0,1-.484,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,34.448,34.448,0,0,1-3.416-6.69,37.76,37.76,0,0,1-3.473,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256a2.676,2.676,0,0,1-.456-4.014,34.617,34.617,0,0,1,5.466-5.238,29.182,29.182,0,0,1-7.459-1Z",
    transform: "translate(-64.5 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46975",
    "data-name": "Path 46975",
    d: "M298.512,207.764a2.847,2.847,0,0,1-2.021-3.644l.142-.37a2.847,2.847,0,0,1,3.729-1.623,32.167,32.167,0,0,1,6.548,3.473,32.6,32.6,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,31.321,31.321,0,0,1-1.253,7.573,33.875,33.875,0,0,1,6.576-3.473,2.676,2.676,0,0,1,3.7,1.68v.256a2.648,2.648,0,0,1-1.936,3.7,32.6,32.6,0,0,1-7.345,1.082A32.2,32.2,0,0,1,317.017,214a2.847,2.847,0,0,1-.484,4.014l-.285.256a2.676,2.676,0,0,1-4.1-.8,32.985,32.985,0,0,1-3.388-6.69,37.638,37.638,0,0,1-3.5,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256a2.676,2.676,0,0,1-.456-4.014,34.616,34.616,0,0,1,5.466-5.238,28.758,28.758,0,0,1-7.374-1Z",
    transform: "translate(-45.844 34.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46976",
    "data-name": "Path 46976",
    d: "M308.652,207.764a2.847,2.847,0,0,1-2.021-3.644v-.37a2.847,2.847,0,0,1,3.73-1.623,32.166,32.166,0,0,1,6.548,3.473,32.611,32.611,0,0,1-1.224-7.573,2.847,2.847,0,0,1,2.847-3.018h.4a2.847,2.847,0,0,1,2.847,3.018,31.315,31.315,0,0,1-1.253,7.573,33.874,33.874,0,0,1,6.576-3.473,2.676,2.676,0,0,1,3.7,1.68v.256a2.648,2.648,0,0,1-1.936,3.7,32.6,32.6,0,0,1-7.345,1.082A32.185,32.185,0,0,1,327.015,214a2.847,2.847,0,0,1-.484,4.014l-.313.256a2.648,2.648,0,0,1-4.071-.8,32.986,32.986,0,0,1-3.388-6.69,37.636,37.636,0,0,1-3.5,6.69,2.648,2.648,0,0,1-4.071.8l-.313-.256a2.676,2.676,0,0,1-.456-4.014,34.613,34.613,0,0,1,5.466-5.238A28.758,28.758,0,0,1,308.652,207.764Z",
    transform: "translate(-27.116 34.882)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAndLoginChangePassword);
export default __webpack_public_path__ + "static/media/security_and_login_change_password.2807f3c5ea091132e59127076e075fcb.svg";
export { ForwardRef as ReactComponent };